/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ value: NonNullable<unknown> }} Measure_Latency_Typical_MeaningInputs */

const en_measure_latency_typical_meaning = /** @type {(inputs: Measure_Latency_Typical_MeaningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Half of requests finish within ${i?.value}`)
};

const zh_hans1_measure_latency_typical_meaning = /** @type {(inputs: Measure_Latency_Typical_MeaningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`一半的请求在 ${i?.value} 内完成`)
};

const pt_br2_measure_latency_typical_meaning = /** @type {(inputs: Measure_Latency_Typical_MeaningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Metade das requisições termina em até ${i?.value}`)
};

const es_measure_latency_typical_meaning = /** @type {(inputs: Measure_Latency_Typical_MeaningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`La mitad de las solicitudes termina en ${i?.value} o menos`)
};

const fr_measure_latency_typical_meaning = /** @type {(inputs: Measure_Latency_Typical_MeaningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`La moitié des requêtes se terminent en ${i?.value}`)
};

const de_measure_latency_typical_meaning = /** @type {(inputs: Measure_Latency_Typical_MeaningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Die Hälfte der Anfragen ist innerhalb von ${i?.value} fertig`)
};

const ru_measure_latency_typical_meaning = /** @type {(inputs: Measure_Latency_Typical_MeaningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Половина запросов завершается за ${i?.value}`)
};

const it_measure_latency_typical_meaning = /** @type {(inputs: Measure_Latency_Typical_MeaningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Metà delle richieste termina entro ${i?.value}`)
};

/**
* | output |
* | --- |
* | "Half of requests finish within {value}" |
*
* @param {Measure_Latency_Typical_MeaningInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const measure_latency_typical_meaning = /** @type {((inputs: Measure_Latency_Typical_MeaningInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Measure_Latency_Typical_MeaningInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_measure_latency_typical_meaning(inputs)
	if (locale === "pt-BR") return pt_br2_measure_latency_typical_meaning(inputs)
	if (locale === "es") return es_measure_latency_typical_meaning(inputs)
	if (locale === "fr") return fr_measure_latency_typical_meaning(inputs)
	if (locale === "de") return de_measure_latency_typical_meaning(inputs)
	if (locale === "ru") return ru_measure_latency_typical_meaning(inputs)
	if (locale === "it") return it_measure_latency_typical_meaning(inputs)
	return en_measure_latency_typical_meaning(inputs)
});